import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Card, Form, Row, Col } from "react-bootstrap";
import IconLoader from "components/IconLoader/IconLoader";

const GeneralSettings = ({ settings, handleInputChange }) => {
  const cardVariants = {
    initial: { scale: 1 },
    hover: { scale: 1.02, boxShadow: "0 10px 20px rgba(0,0,0,0.1)" },
    tap: { scale: 0.98 }
  };

  return (
    <motion.div
      initial={{ y: 40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.2 }}
    >
      <motion.div variants={cardVariants} initial="initial" whileHover="hover">
        <Card className="shadow-sm mb-0">
          <Card.Header className="bg-white py-3 cursor-pointer">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">
                <IconLoader icon="mdiCog" className="mr-2 text-primary" /> Genel Ayarlar
              </h5>
            </div>
          </Card.Header>
          <AnimatePresence>
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.3 }}
            >
              <Card.Body>
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Label>Site Adı</Form.Label>
                    <Form.Control
                      type="text"
                      name="siteName"
                      value={settings?.siteName || ""}
                      onChange={handleInputChange}
                      disabled
                    />
                  </Form.Group>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>İletişim E-postası</Form.Label>
                        <Form.Control
                          type="email"
                          name="contactEmail"
                          value={settings?.contactEmail || ""}
                          onChange={handleInputChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>İletişim Telefonu</Form.Label>
                        <Form.Control
                          type="text"
                          name="contactPhone"
                          value={settings?.contactPhone || ""}
                          onChange={handleInputChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </motion.div>
          </AnimatePresence>
        </Card>
      </motion.div>
    </motion.div>
  );
};

export default GeneralSettings;
